import React from 'react';

function DummyTest({ src, alt, sizes = '100vw' }) {
  const baseUrl = 'https://d2lhwh4zy374ln.cloudfront.net';

  const resolutions = [
    { width: 480, height: 340 },
    { width: 720, height: 500 },
    { width: 1080, height: 720 },
    { width: 1440, height: 960 },
    { width: 2160, height: 1440 },
    { width: 2880, height: 1920 },
    { width: 3840, height: 2160 },
  ];

  const srcSet = resolutions
    .map(({ width, height }) => `${baseUrl}/fit-in/${width}x${height}/${src} ${width}w`)
    .join(', ');

  return (
    <img
      src={`${baseUrl}/fit-in/1080x720/${src}`} // fallback
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      loading="lazy"
      style={{ width: '100%', height: 'auto', display: 'block' }}
    />
  );
}

export default DummyTest;
